const styles = (theme) => ({
  wrapper: {
    position: 'fixed',
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 2,
    textAlign: 'center',
  },
  button: {
    fontSize: 16,
    height: 80,
    maxWidth: theme.breakpoints.values.sm,
  },
});

export default styles;
